<template>
  <div class="root">
    <div class="content">
      <component :is="BusinessComponent"></component>
    </div>
    <div class="float_button">
      <keep-alive>
        <component :is="CommonOpenButton"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script lang="ts" setup name="BaseAbility">
import { onMounted } from 'vue';
import BusinessComponent from '../components/BusinessComponent.vue';
import CommonOpenButton from '../components/CommonOpenButton.vue';
import AppLinkStat from '../stats/AppLinkStat';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';
import PageParamsUtil from '../../utils/PageParamsUtil';
import DeviceEnvUtil from '@/utils/DeviceEnvUtil';

// document.addEventListener(
//   'touchstart',
//   function (event) {
//     if (event.touches.length > 1) {
//       event.preventDefault();
//     }
//   },
//   {
//     capture: false,
//     passive: false,
//   },
// );
onMounted(() => {
  AppLinkStat.eventAbilityPageShow(
    AbilityParamsUtil.getAbilityName(),
    AbilityParamsUtil.getAbilityBusinessId(),
    PageParamsUtil.getPageUrl(),
  );

  // fix issue： Chrome mobile onResume is not defined
  if (DeviceEnvUtil.isAndroid()) {
    if (typeof window.onResume !== 'function') {
      window.onResume = function () {
        console.log('[H5] onResume called');
      };
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.root {
  position: relative;
  width: 100%;
  height: 100%;
}

.content {
  position: absolute;
  width: 100%;
  height: 100%;
}

.float_button {
  position: fixed;
  width: 100%;
  height: 100%;
}
</style>
